<!-- Sections are separated by their own top padding and hairlines rather than by
     card chrome — see the section headers inside each component. The dot field's
     readability veil lives in the layout, pinned to the card. -->
<!-- Each section fetches data in ngOnInit, so switching organizations must recreate them. -->
@for (organizationId of [currentOrgStore.organizationId()]; track organizationId) {
  <div class="flex flex-col pb-10">
    <app-dashboard-metrics />
    @if (currentOrgStore.organization(); as org) {
      <app-solar-map class="block pt-8 pb-2" [organizationId]="org.id" [organizationSlug]="org.slug" />
    }
    <app-action-needed />
    <app-dashboard-charts />
    <app-latest-activity />
    <app-active-campaigns />
  </div>
}
